import PropTypes from "prop-types";

// Layouts
import PayPlansFacade from "@PayPlans/Layouts/PayPlansFacade";

// Model
import PayPlansModel from "@PayPlans/models/Managers/Departmental";

function Departmental({ position = "", positionType = "Departmental", defaultSections = [] }) {
	return (
		<PayPlansFacade
			position={position}
			positionType={positionType}
			defaultSections={defaultSections}
			cacheManagement={{
				clearAbsoluteIndexes: [
					"programDetails",
					"payPlanCsiMetrics",
					"payPlansSidebarTree",
					"payPlanSalesPerformanceReportVersions",
					"locationFS",
				],
			}}
		>
			<PayPlansModel />
		</PayPlansFacade>
	);
}
Departmental.propTypes = {
	position: PropTypes.string,
	positionType: PropTypes.string,
	defaultSections: PropTypes.arrayOf(PropTypes.string),
};

export default Departmental;
